/**
 * @generated SignedSource<<d6841b8e30fc4b85bd3fa8dd19137dc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemindersCreateMutationInput = {
  clientMutationId?: string | null;
  memberIds: ReadonlyArray<string>;
  message: string;
  nodeId: string;
};
export type ReminderModal_createReminder_Mutation$variables = {
  input: RemindersCreateMutationInput;
};
export type ReminderModal_createReminder_Mutation$data = {
  readonly createReminder: {
    readonly success: boolean | null;
  } | null;
};
export type ReminderModal_createReminder_Mutation = {
  response: ReminderModal_createReminder_Mutation$data;
  variables: ReminderModal_createReminder_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemindersCreateMutationPayload",
    "kind": "LinkedField",
    "name": "createReminder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReminderModal_createReminder_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReminderModal_createReminder_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3648c7328c35d054a773b3e0f27e35fd",
    "id": null,
    "metadata": {},
    "name": "ReminderModal_createReminder_Mutation",
    "operationKind": "mutation",
    "text": "mutation ReminderModal_createReminder_Mutation(\n  $input: RemindersCreateMutationInput!\n) {\n  createReminder(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "d472ba8bf5fe9039d0b79b774b48c23f";

export default node;
